const filterFunction = function() {
    const labels = document.querySelectorAll('#team_filter');
    const searchText = document.getElementById('searchInput').value.toLowerCase();

    labels.forEach(label => {
        const labelTxt = label.textContent.toLowerCase();
        const checkboxContainer = label.parentElement;

        if (labelTxt.includes(searchText)) {
            checkboxContainer.style.display = 'flex';
        } else {
            checkboxContainer.style.display = 'none';
        }
    });
};

const sortFunction = function() {
    var collapsibleContents = document.querySelectorAll('.collapsible__content');

    collapsibleContents.forEach(function(content) {
        var orderNames = content.querySelectorAll('[order-name]');
        var sortedOrderNames = Array.from(orderNames).sort(function(a, b) {
            var nameA = a.getAttribute('order-name').toUpperCase();
            var nameB = b.getAttribute('order-name').toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });

        sortedOrderNames.forEach(function(orderName) {
            content.appendChild(orderName);
        });
    });
};

function onPageLoad() {
    filterFunction();
    sortFunction();
    document.getElementById('searchInput').addEventListener('input', filterFunction);
}

document.addEventListener("DOMContentLoaded", onPageLoad);

setInterval(onPageLoad, 500);
